import { computed, state } from 'ccstate'
import { apiClient$ } from '../infra/apiClient'

export const favoritesDirty$ = state(1)

export const favorites$ = computed(async (get) => {
  get(favoritesDirty$)
  const apiClient = get(apiClient$)
  const result = await apiClient.getApi('getFavorites', {})
  return result.favorites
})
